/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use it for Scrabble or Words With Friends?`)
};

const es_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usarlo para Scrabble o Words With Friends?`)
};

const de_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich es für Scrabble oder Words With Friends nutzen?`)
};

const nl_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik dit gebruiken voor Scrabble of Words With Friends?`)
};

const fr_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je l'utiliser pour Scrabble ou Words With Friends ?`)
};

const it_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usarlo per Scrabble o Words With Friends?`)
};

const pt_br2_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar para Scrabble ou Words With Friends?`)
};

const pt_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso utilizá-lo para o Scrabble ou o Words With Friends?`)
};

const ja_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScrabbleやWords With Friendsに使えますか？`)
};

const zh_wu_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以用于 Scrabble 或 Words With Friends 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq3_q", locale)
	if (locale === "en") return en_wu_hub_faq3_q(inputs)
	if (locale === "es") return es_wu_hub_faq3_q(inputs)
	if (locale === "de") return de_wu_hub_faq3_q(inputs)
	if (locale === "nl") return nl_wu_hub_faq3_q(inputs)
	if (locale === "fr") return fr_wu_hub_faq3_q(inputs)
	if (locale === "it") return it_wu_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq3_q(inputs)
	if (locale === "pt") return pt_wu_hub_faq3_q(inputs)
	if (locale === "ja") return ja_wu_hub_faq3_q(inputs)
	return zh_wu_hub_faq3_q(inputs)
};